/**
 * Said on a project's page when okthx could not read the label this time.
 *
 * The page needs saying so because nothing else on it shows the failure: a
 * reading that did not happen leaves no missing parts, and no missing parts is
 * also what a goal every task covers looks like. Without this sentence the two
 * read the same, and the quieter one is wrong.
 *
 * Two sentences, because a label read before has words on the page that are now
 * out of date, where one never read has nothing there to qualify.
 *
 * Shared because both project pages draw it, and because the actor says the
 * same thing in its own words in `tasksListModule`: three surfaces, one answer.
 */
export const readingFailedLine = (hasContext: boolean): string =>
  hasContext
    ? "Okthx couldn't read this just now, so this is where it stood when it last could."
    : "Okthx couldn't read this label just now.";
